module.exports = __webpack_public_path__ + "img/IMG-20230301-WA0001.b7ee9b86.jpg";